<template>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-subheader ">
            <div class="d-flex align-items-center">
                <div class="mr-auto">
                    <h3 class="m-subheader__title m-subheader__title--separator">
                        POI images upload
                    </h3>
                    <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                        <li class="m-nav__item m-nav__item--home">
                            <router-link exact :to="{ name: 'home' }" class="m-nav__link m-nav__link--icon">
                                <i class="m-nav__link-icon la la-home"></i>
                            </router-link>
                        </li>
                        <li class="m-nav__separator">
                            -
                        </li>
                        <li class="m-nav__item">
                            <router-link exact :to="{ name : 'location_image_uploader' }" class="m-nav__link"><span
                                    class="m-nav__link-text">POI images upload</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="m-content">
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 class="m-portlet__head-text">
                                Uploader
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                        <ul class="m-portlet__nav">
                            <li class="m-portlet__nav-item">
                                <button type="button" v-if="!isDisabled" class="btn btn-secondary"
                                        @click="disableInput()">Cancel
                                </button>
                            </li>
                            <li class="m-portlet__nav-item">
                                <button type="button" v-if="isDisabled" class="btn btn-brand" @click="enableInput()">
                                    Edit
                                </button>
                                <button type="button" v-if="!isDisabled" class="btn btn-brand" @click="saveInput()">
                                    Save
                                </button>

                            </li>
                        </ul>
                    </div>

                </div>
                <form class="m-form m-form--label-align-right">
                    <div class="m-portlet__body">
                        <div class="m-form__content">
                            <div class="m-alert m-alert--icon alert alert-danger" role="alert" v-if="error"
                                 id="m_form_1_msg">
                                <div class="m-alert__icon">
                                    <i class="la la-warning"></i>
                                </div>
                                <div class="m-alert__text" v-html="message">
                                </div>
                                <div class="m-alert__close">
                                    <button type="button" class="close" @click="error=false"
                                            aria-label="Close"></button>
                                </div>
                            </div>
                        </div>
                        <div class="m-form__section m-form__section--first">
                            <div class="form-group m-form__group row">
                                <label for="bus-stop-icon" class="col-lg-2 col-form-label">
                                    Bus stop icon
                                </label>
                                <div class="col-lg-6">
                                    <input :disabled="isDisabled === true" type="file"
                                           v-on:change="handleFile('donation-icon')"
                                           id="bus-stop-icon"
                                           class="form-control m-input">
                                </div>
                                <div class="col-lg-3">
                                    <img width="40" height="40" alt="bus-stop-icon" v-bind:src="icons.bus_stop"></img>
                                </div>
                            </div>

                        </div>
                        <div class="m-form__section m-form__section--first">
                            <div class="form-group m-form__group row">
                                <label for="parking-icon" class="col-lg-2 col-form-label">
                                    Bus stop icon
                                </label>
                                <div class="col-lg-6">
                                    <input :disabled="isDisabled === true" type="file"
                                           v-on:change="handleFile('parking-icon')"
                                           id="parking-icon"
                                           class="form-control m-input">
                                </div>
                                <div class="col-lg-3">
                                    <img width="40" height="40" alt="parking-icon" v-bind:src="icons.parking"></img>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import SettingApi from '../../api/setting';

    export default {
        components: {},
        name: "DonationSetting",
        data() {
            return {
                error: false,
                isDisabled: true,
                icons: {},
                message: null
            }
        },
        created() {
            this.fetchData()
        },
        watch: {
            '$route': 'fetchData'
        },
        methods: {
            fetchData() {
                SettingApi.getPoiImageInfo(this, {}, (context) => {
                    if (context.settings) {
                        context.settings.forEach(setting => {
                            if (setting.poi_images) {
                                console.log(setting.poi_images);
                            }
                        })
                    }
                });
            },
            handleFile(id) {
                let file = document.querySelector('#' + id);
                if (typeof file.files[0] != 'undefined') {
                    this.fileHelper.getBase64(file.files[0], this, (context) => {
                        if (context) {
                            if (id === 'icon') {
                                this.icon = context.currentFile;
                            } else if (id === 'active_icon') {
                                this.active_icon = context.currentFile;
                            } else {
                                let file = document.querySelector('#' + id);
                                file.value = null;
                            }
                        } else {
                            let file = document.querySelector('#' + id);
                            file.value = null;
                        }
                    });
                } else {
                    this.icon = null;
                    this.active_icon = null;
                    this.currentFile = null;
                }
            },
            enableInput() {
                this.isDisabled = false;
            },
            disableInput() {
                this.isDisabled = true;
            },
            saveInput() {
                this.error = false;
                if (this.donationSetting) {
                    this.donationSetting.forEach(setting => {
                        let data = {
                            'setting_code': setting,
                            'setting_value': '',
                        };

                        if (setting === 'donation_amounts') {
                            data.setting_value = JSON.stringify(this.amounts);

                        } else if (setting === 'donation_contents') {
                            data.setting_value = JSON.stringify({
                                icon: {
                                    path: this.icon
                                },
                                description: this.description
                            });
                        }
                        SettingApi.updateDonationSetting(this, setting, data, (context) => {
                            if (context.success) {
                                this.message = 'Update setting successful';
                            }
                        });
                    })

                }
            }
        }
    }
</script>

<style scoped>

</style>